import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { changeLanguage } from '../features/system/slice';

const NotExistUI = ({unavailable, available}) => {
  const dispatch = useDispatch()
  const renderLanguageCode = (code) => {
    return code === 'en' ? 'English' : code === 'id' ? 'Bahasa Indonesia' : '-'
  }

  const handleChange = () => {
    dispatch(changeLanguage(available))
  }

  return (
    <div className="text-center lg:py-16">
      <p className="text-lg font-bold mb-3 lg:mb-5">
        This content is not exist in {renderLanguageCode(unavailable)}
      </p>
      <p className="link text-sm" onClick={handleChange}>
        Change to {renderLanguageCode(available)}?
      </p>
    </div>
  )
}

const LanguageChecker = ({ data = {}, children }) => {
  const language = useSelector(state => state.system.language)

  const checkAvailability = (string) => {
    if(
      !string
      || string === 'N/A'
      || string === '<p>N/A</p>'
      || string.toLowerCase() === 'default'
    ){
      return false
    }

    return true
  }

  const availability = {
    en: checkAvailability(data.en),
    id: checkAvailability(data.id)
  }

  const {en, id} = availability

  const everythingIsGood = (en === true && id === true) || (availability[language.name] === true)
  const showEnOnlyWarning = en === true && id === false && language.name === 'id'
  const showIdOnlyWarning = id === true && en === false && language.name === 'en'

  return (
    <>
      {
        everythingIsGood ? (
          children
        ) : showEnOnlyWarning ? (
          <NotExistUI unavailable="id" available="en"/>
        ) : showIdOnlyWarning ? (
          <NotExistUI unavailable="en" available="id"/>
        ) : <></>
      }
    </>
  )
}

export { LanguageChecker }
